export default {"src":"/_next/static/image/public/images/flags/flag_33.abb25944f46616e5bdfa36dbae4174dd.svg","height":16,"width":24};